/**
 * File navigation.js.
 *
 * Handles toggling the navigation menu for small screens and enables TAB key
 * navigation support for dropdown menus.
 */

 jQuery(document).ready(function ($) {
  $(document).on("click",".header-user-image",function() {
    if ($('.header-user-menu').hasClass('active-hover')) {
      $('.header-user-menu').removeClass('active-hover');
      $('.header-user-image').removeClass('active-hover');
      $('header').removeClass('active');
    }
    else {
      $('.header-user-menu').addClass('active-hover');
      $('.header-user-image').addClass('active-hover');
      $('header').addClass('active');
    }
  })

  $(document).on("click",".header-lang .wpml-ls-item",function() {
    if ($('.header-lang .wpml-ls-sub-menu').hasClass('wpml-ls-sub-menu-lib')) {
      if ($('.header-lang .wpml-ls-sub-menu').hasClass('active')) {
        $('.header-lang .wpml-ls-sub-menu').removeClass('active');
      }
      else {
        $('.header-lang .wpml-ls-sub-menu').addClass('active');
        $(document).on("click",checkDocumentClick);
      }
    }
  });

  $('.header-user-image').blur(function () {
    $('.header-user-menu').removeClass('active-hover');
    $('.header-user-image').addClass('active-hover');
    $('header').removeClass('active');
  })

  $(document).mouseup(function (e) {
    var container = $(".header-user-data");
    if (!container.is(e.target) && container.has(e.target).length === 0) {
      $('.header-user-menu').removeClass('active-hover');
      $('.header-user-image').removeClass('active-hover');
      $('header').removeClass('active');
    }
  });


  $(document).on("click",".notis-yes",function() {
    if ($('.notifications-wrapper').hasClass('active')) {
      closeModal();
    }
    else {
      $('.notifications-wrapper').addClass('active');
      $('header').addClass('active');
      $('.modal-transparent').addClass('active');
      $('body').addClass('fixed');
      $('header').css('z-index','100');
    }
  });

  $(document).on("click",".notifications-close-icon",function() {
    closeModal();
  });

  $(document).on("click","[close-reminders-modal]",function() {
    closeModal();
  });

  $(document).on("click",".close-notis",function() {
    closeModal();
  });

  $(document).on("click",".header-menu li.menu-item",function() {
    if ($(this).hasClass('active')) {
      $(this).removeClass('active');
    }
    else {
      $('.header-menu li.menu-item').removeClass('active');
      $(this).addClass('active');
    }
  });

  function closeModal() {
    $('.login-mobile').removeClass('active');
    $('.notifications-wrapper').removeClass('active');
    $('header').removeClass('active');
    $('.modal-transparent').removeClass('active');
    $('body').removeClass('fixed');
    $('header').css('z-index','110');
  }

  $(document).on("click",".login-mobile a",function() {
    if ($('.login-mobile').hasClass('active')) {
      closeModal();
    }
    else {
      $('.login-mobile').addClass('active');
      $('header').addClass('active');
      $('body').addClass('fixed');
      $('.modal-transparent').addClass('active');
    }
  });

  $(document).on("click",".login-mobile > a",function(event) {
    event.preventDefault();
  });

  $(document).on("click",".modal-transparent",function() {
    closeModal();
  })

  $(document).on("click",".burger--to-x",function() {
    $('.burger--to-x').toggleClass('active');
    $('header').toggleClass('mobile-active');
    $('.header-menu').toggleClass('active');
    $('.header-right-logged').toggleClass('hide');
  });

  $(window).resize(function() {
    if($('.burger--to-x').hasClass('active')){
      $('.burger--to-x').removeClass('active');
    $('header').removeClass('mobile-active');
    $('.header-menu').removeClass('active');
    $('.header-right-logged').removeClass('hide');
    }
  });

  $(document).on("click",".footer-menu .menu-item-has-children",function(e) {
    e.preventDefault();
    if($(this).find('.sub-menu').hasClass('active')) {
      $(".footer-menu .menu-item-has-children .sub-menu").removeClass('active');
      $(".footer-menu .menu-item-has-children").removeClass('active');
    }
    else {
      $(".footer-menu .menu-item-has-children .sub-menu").removeClass('active');
      $(this).find('.sub-menu').addClass('active');
      $(".footer-menu .menu-item-has-children").removeClass('active');
      $(this).addClass('active');
    }
  })

  $(document).on("click",".footer-menu .menu-item-has-children .menu-item",function(e) {
    e.stopPropagation();
  });

  $(document).on("click",".header-menu .menu-item-has-children > a",function(e) {
      e.preventDefault();
    });

  $('.footer-language .selector-countries').click(function(e) {
    e.stopPropagation();
    if($('.selector-countries-container').hasClass('active')){
      $('.selector-countries-container').removeClass('active');
    }
    else {
      var height = $('.selector-countries-container').height();
      $('.selector-countries-container').css('top',(height*-1)-40+'px');
      $('.selector-countries-container').addClass('active');
      $(document).on("click",checkMenuCountries);
    }
    
  });

  $("#menu-lang-mobile").on("click", (event) => {
    event.stopPropagation();
    $("#menu-lang-list-mobile").css("display", "block");
    $(document).on("click", checkMenuLangMobileClick);
  });

});


jQuery(window).on("scroll", function () {
  if (jQuery('.header-user-menu').hasClass('active-hover')) {
    jQuery('.header-user-menu').removeClass('active-hover');
    jQuery('.header-user-image').removeClass('active-hover');
    jQuery('header').removeClass('active');
  }
  if (jQuery(window).scrollTop() > 1) {
    jQuery('header').addClass('active');

  } else {
    jQuery('header').removeClass('active');
  }
});

function checkDocumentClick(event) {
  const target = $(event.target);

  if(!target.is('.header-lang .wpml-ls-sub-menu') && $('.header-lang .wpml-ls-sub-menu').has(target).length===0){
    $(document).unbind("click",checkDocumentClick);
    $('.header-lang .wpml-ls-sub-menu').removeClass('active');
  }
}

function checkMenuCountries(event) {
  const target = jQuery(event.target);
  if(!target.is('.selector-countries-container') && jQuery('.selector-countries-container').has(target).length===0){
      jQuery(document).unbind("click",checkMenuCountries);
      jQuery('.selector-countries-container').removeClass('active');
  }
}

function checkMenuLangMobileClick(event) {
  const target = $(event.target);
  const languagesList = $("#menu-lang-list-mobile").css("display", "block");

  if (!target.is(languagesList) || languagesList.has(target).length === 0) {
    languagesList.css("display", "none");
    $(document).off("click", checkMenuLangMobileClick);
  }
}